import React, {
  useMemo, 
} from 'react';
import { useSelector } from 'react-redux';
import CostGraph from '@App/components/BuildingDamages/CostGraph/CostGraph';

import { calculateCostPerClass, calculateTotalDamage } from '../building-damages.utils';

import './compare-mode-view.styl'
import CompareModeTable from './CompareModeTable/CompareModeTable';
import PEValueGraph from '../../PEValueGraph/PEValueGraph';
import RiskDistributionGraph from '../../RiskDistributionGraph/RiskDistributionGraph';

function CompareModeView() {
  const currentSelectedDamageLayer = useSelector(state => state.layerSelector.currentSelectedDamageLayer)
  const secondScenario = useSelector(state => state.buildingDamages.secondScenario)
  const featureOne = currentSelectedDamageLayer.features
  const featureTwo = useMemo(() => (secondScenario ? secondScenario.features : []), [secondScenario])

  const scenarioOnecostPerClass = useMemo(() => calculateCostPerClass(featureOne), [featureOne]);
  const scenarioTwocostPerClass = useMemo(() => calculateCostPerClass(featureTwo), [featureTwo]);

  const totalDamageScenario1 = calculateTotalDamage(currentSelectedDamageLayer?.features)
  const totalDamageScenario2 = calculateTotalDamage(secondScenario?.features);
  const userSelectedMode = useSelector(state => state.maplibreMap.userSelectedMode);

  return (
    <div className="compare-mode-view">
      {userSelectedMode === 'River flood' ? (
        <div>
          <div className="compare-mode-view__graphs">
            <div className="compare-mode-view__graphs__scenario-one">
              <span>Scenario 1</span>
              <CostGraph data={scenarioOnecostPerClass} totalDamage={totalDamageScenario1} width={380} />
            </div>
            <div className="compare-mode-view__graphs__scenario-two">
              <span>Scenario 2</span>
              {secondScenario ? (
                <CostGraph data={scenarioTwocostPerClass} totalDamage={totalDamageScenario2} width={380} />
              ) : (
                <span className="compare-mode-view__noscenario">Select a scenario to load the results</span>
              )}
            </div>
          </div>
      
          <div className="compare-mode-view__tabels">
            <CompareModeTable scenarioOne={scenarioOnecostPerClass} scenarioTwo={scenarioTwocostPerClass} />
          </div>
        </div>
      ) : (
        <div className="compare-mode-view__flash-flood">
          <div className="compare-mode-view__graphs__flash">
            {/* <div style={{ width: '100px' }} /> */}
            <div className="compare-mode-view__graphs__scenario-one">
              <span>Scenario 1</span>
              <PEValueGraph currentSelectedDamageLayer={currentSelectedDamageLayer} />
            </div>
            <div className="compare-mode-view__graphs__scenario-two">
              <span>Scenario 2</span>
              {secondScenario ? (
                <PEValueGraph currentSelectedDamageLayer={secondScenario} />
              ) : (
                <span className="compare-mode-view__noscenario">Select a scenario to load the results</span>
              )}
            </div>
          </div>
          <div className="compare-mode-view__graphs__flash">
            <div className="compare-mode-view__graphs__scenario-one risk-distribution">
              <span>Scenario 1</span>
              <RiskDistributionGraph currentSelectedDamageLayer={currentSelectedDamageLayer} height={300} />
            </div>
            <div className="compare-mode-view__graphs__scenario-two risk-distribution">
              <span>Scenario 2</span>
              {secondScenario ? (
                <RiskDistributionGraph currentSelectedDamageLayer={secondScenario} height={300} />
              ) : (
                <span className="compare-mode-view__noscenario">Select a scenario to load the results</span>
              )}
            </div>
          </div>
        </div>
      )}
      
    </div>
  )
}

export default CompareModeView